import { fromJS } from 'immutable'
import { SET_STORE } from './actionTypes'

export const openAddressValidationErrorMessageDialog = (payload) => (dispatch, getState) => {
  dispatch({
    type: SET_STORE,
    payload: {
      store: getState().setIn(
        ['ftModals', 'addressValidationErrorMessage'],
        fromJS({
          open: true,
          validationDetails: payload.validationDetails,
          showSuggestedAddress: payload.showSuggestedAddress,
        })
      ),
    },
  })
}

export const closeAddressValidationErrorMessageDialog = () => (dispatch, getState) => {
  dispatch({
    type: SET_STORE,
    payload: {
      store: getState().setIn(['ftModals', 'addressValidationErrorMessage', 'open'], false),
    },
  })
}
